"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets) {
        var views;
        (function (views) {
            var createWizard2_fields;
            (function (createWizard2_fields) {
                let DatasetCreationMethod;
                (function (DatasetCreationMethod) {
                    DatasetCreationMethod["None"] = "None";
                    DatasetCreationMethod["Manual"] = "Manual";
                    DatasetCreationMethod["FormScreen"] = "FormScreen";
                    DatasetCreationMethod["DataSource"] = "DataSource";
                    DatasetCreationMethod["FileUpload"] = "FileUpload";
                })(DatasetCreationMethod || (DatasetCreationMethod = {}));
                class InitArgs {
                    constructor() {
                        this.wizardToken = '';
                        this.creationMethod = DatasetCreationMethod.None;
                        this.selectedAutoFields = [];
                        this.selectedSingularFields = [];
                        this.selectedRepeatFields = [];
                        this.generateRepeatRows = false;
                        this.hasSingleRepeat = false;
                        this.repeatGroups = [];
                        this.repeatFieldsByAnchor = {};
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    $(function () {
                        var _a;
                        bindEvents();
                        if (_initArgs.generateRepeatRows) {
                            const anchor = (_a = $('#repeatAnchorPicker').val()) === null || _a === void 0 ? void 0 : _a.toString();
                            if (anchor)
                                handleRepeatAnchorChange(anchor);
                        }
                    });
                }
                createWizard2_fields.init = init;
                function getParentButton(selector) {
                    return $(parent.document).find(selector);
                }
                function bindEvents() {
                    getParentButton('#wizardBackBtn').on('click', function (e) {
                        e.preventDefault();
                        window.location.href = _initArgs.urls.navigateToStep + '?step=2&token=' + _initArgs.wizardToken;
                    });
                    getParentButton('#wizardNextBtn').on('click', function () {
                        if (validateStep())
                            submitForm();
                    });
                    $(document).on('change', '#GenerateRepeatRows', function () {
                        var _a;
                        const checked = $(this).is(':checked');
                        if (checked) {
                            $('#repeatAnchorWrapper').removeClass('d-none');
                            const anchorName = ((_a = $('#repeatAnchorPicker').val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                            if (anchorName)
                                handleRepeatAnchorChange(anchorName);
                        }
                        else
                            $('#repeatAnchorWrapper, #repeatFieldsSection').addClass('d-none');
                        appn.iframe.setModalIframeHeight(true);
                    });
                    $(document).on('change', '#repeatAnchorPicker', function () {
                        var _a;
                        const anchorName = ((_a = $(this).val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                        handleRepeatAnchorChange(anchorName);
                    });
                }
                function handleRepeatAnchorChange(anchorName) {
                    const $select = $('#repeatFieldsSelect');
                    $select.empty();
                    const isGenerating = $('#GenerateRepeatRows').is(':checked');
                    if (anchorName && isGenerating) {
                        const columns = _initArgs.repeatFieldsByAnchor[anchorName] || [];
                        columns.forEach(col => {
                            if (col.alwaysIncluded)
                                return;
                            const isSelected = _initArgs.selectedRepeatFields.includes(col.id);
                            $select.append(`<option value="${col.id}" ${isSelected ? 'selected' : ''}>${col.displayName}</option>`);
                        });
                        $('#repeatFieldsSection').removeClass('d-none');
                        $select.bootstrapDualListbox('refresh');
                    }
                    else {
                        $('#repeatFieldsSection').addClass('d-none');
                    }
                }
                function validateStep() {
                    var _a, _b;
                    if ($('#GenerateRepeatRows').is(':checked')) {
                        const anchor = ((_a = $('#repeatAnchorPicker').val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                        if (!anchor) {
                            appn.toast.notify(appn.toast.Type.error, T('Please choose a repeat group from which to generate rows.'));
                            return false;
                        }
                        const repeatCount = ((_b = $('#repeatFieldsSelect').val()) === null || _b === void 0 ? void 0 : _b.length) || 0;
                        if (repeatCount === 0) {
                            appn.toast.notify(appn.toast.Type.error, T('At least one repeat field must be selected when generating rows.'));
                            return false;
                        }
                    }
                    return true;
                }
                function submitForm() {
                    $('form')[0].submit();
                }
            })(createWizard2_fields = views.createWizard2_fields || (views.createWizard2_fields = {}));
        })(views = datasets.views || (datasets.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
